import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import * as _ from "lodash";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { VendorService } from "../../../services/api/vendor.service";
import { VendorActions } from "../../actions/vendor.actions";
import { FailState } from "../../models/fail-state";

@Injectable()
export class BeneficiaryCreateEffects {
	create = createEffect(() =>
		this.actions.pipe(
			ofType(VendorActions.beneficiary.create),
			switchMap((action) =>
				this.vendorService.beneficiaryCreate(_.omit(action, "type")).pipe(
					map(() => VendorActions.beneficiary.createSuccess()),
					catchError((error) =>
						of(VendorActions.beneficiary.createFail(new FailState(error)))
					)
				)
			)
		)
	);

	constructor(
		private actions: Actions,
		private vendorService: VendorService
	) {}
}
